
export const cardStyles = {
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
};

export const cardTitleStyles = {
  display: 'inline-block',
  marginBottom: '0',
  fontWeight: '400',
  fontSize: '1.3em',
  lineSpacing: '.5px',
  marginTop: '.1em'
};

export const labelStyles = {
  fontSize: '11px',
  lineHeight: '1.07143',
  color: '#AAAAAA',
  fontWeight: '400'
};

export const buttonStyles = {
  borderRadius: '3px',
  marginLeft: '.5em'
};

export const cardHeaderStyles = {
  paddingBottom: '.6em',
  backgroundColor: 'whitesmoke',
  marginBottom: '.9em'
};

export const formGroupStyles = {
  marginBottom: '2em'
};
